import { Component, Input, Output, EventEmitter } from '@angular/core';

import styles from './approver-request.module.less';

@Component({
	selector: 'approval-submit-btn',
	templateUrl: './ApprovalSubmitBtn.Component.html'
})
export class ApprovalSubmitBtnComponent {
	@Input() public templateListCount: number;
	@Input() public isSubmitted: boolean;
	@Input() public isTemplateSelected: boolean;
	@Output() public onApprovalSubmit: EventEmitter<void> = new EventEmitter();

	public readonly styles = styles;

	public get isMoreThanOneTemplate(): boolean {
		return this.templateListCount > 1;
	}

	public approvalSubmit(): void {
		this.onApprovalSubmit.emit();
	}
}
